import { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';

const ms = (v) => v?.toDate?.().getTime() ?? 0;

// Kundens egne saker (sanntid). Filteret på userUid er påkrevd av sikkerhetsreglene.
export function useMyCases() {
  const { currentUser } = useAuth();
  const uid = currentUser?.uid;
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!uid) { setLoading(false); return undefined; }
    return onSnapshot(query(collection(db, 'supportCases'), where('userUid', '==', uid)), (snap) => {
      setCases(snap.docs.map(d => ({ id: d.id, ...d.data() })).sort((a, b) => ms(b.lastMessageAt) - ms(a.lastMessageAt)));
      setLoading(false);
    }, () => { setCases([]); setLoading(false); });
  }, [uid]);

  return { cases, loading };
}

// Meldinger i én sak, eldst først. Filtrerer på både sak og eier (kreves av reglene).
export function useCaseMessages(caseId) {
  const { currentUser } = useAuth();
  const uid = currentUser?.uid;
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    if (!caseId || !uid) { setMessages([]); return undefined; }
    return onSnapshot(
      query(collection(db, 'supportMessages'), where('caseId', '==', caseId), where('userUid', '==', uid)),
      (snap) => setMessages(snap.docs.map(d => ({ id: d.id, ...d.data() })).sort((a, b) => ms(a.at) - ms(b.at))),
      () => setMessages([]),
    );
  }, [caseId, uid]);

  return { messages };
}
